import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, exhaustMap, map } from 'rxjs/operators';
import { CategoryService } from '@modules/shared/services/category.service';
import { CategoryActions } from '@store/actions/category.actions';
import { UpdateCategoryRequest } from '@models/category.model';

@Injectable()
export class CategoryEffects {
  private readonly actions$ = inject(Actions);
  private readonly categoryService = inject(CategoryService);

  getCategories$ = createEffect(() => this.actions$.pipe(
      ofType(CategoryActions.GET_CATEGORIES),
    exhaustMap(({payload}: { payload: string }) => this.categoryService.getAll(payload)
        .pipe(
          map(payload => ({type: CategoryActions.GET_CATEGORIES_SUCCESS, payload})),
          catchError(error => of(({type: CategoryActions.GET_CATEGORIES_FAILED, error}))),
        )),
    ),
  );

  updateCategory$ = createEffect(() => this.actions$.pipe(
      ofType(CategoryActions.UPDATE_CATEGORY),
    exhaustMap(({payload}: { payload: UpdateCategoryRequest }) => {
      return this.categoryService.update(payload)
        .pipe(
          map(payload => ({type: CategoryActions.UPDATE_CATEGORY_SUCCESS, payload})),
          catchError(error => of(({type: CategoryActions.UPDATE_CATEGORY_FAILED, error}))),
        )
    }),
    ),
  );

  createCategory$ = createEffect(() => this.actions$.pipe(
      ofType(CategoryActions.CREATE_CATEGORY),
      exhaustMap(({payload}: { payload: UpdateCategoryRequest }) => this.categoryService.create(payload)
        .pipe(
          map(payload => ({type: CategoryActions.CREATE_CATEGORY_SUCCESS, payload})),
          catchError(error => of(({type: CategoryActions.CREATE_CATEGORY_FAILED, error}))),
        )),
    ),
  );

  deleteCategory$ = createEffect(() => this.actions$.pipe(
      ofType(CategoryActions.DELETE_CATEGORY),
      exhaustMap(({payload}: {
        payload: { webshopId: string, categoryId: string }
      }) => this.categoryService.delete(payload)
        .pipe(
          map((id) => ({type: CategoryActions.DELETE_CATEGORY_SUCCESS, payload: payload.categoryId})),
          catchError(error => of(({type: CategoryActions.DELETE_CATEGORY_FAILED, error}))),
        )),
    ),
  );
}
